<template>
  <div class="container">
		<div class="conmonContent">
			<div class="w1600">
				<div class="otDetail d-flex j-sb">
					<!-- 左侧详情 -->
					<div class="otLeftContent">
						<!-- 视频区 -->
						<div class="tVideo bd10 p3">
							<div class="video">
								<video v-if="videoUrl" ref="video" :poster="videoPoster" x5-video-player-type='h5' x5-video-player-fullscreen="true" playsinline="true" webkit-playsinline="true" :src="videoUrl" controls></video>
							</div>
							<h3 class="font36 line-sm">{{content.details.title}}</h3>
							<div class="tagList">
								<i v-for="(item, index) in content.details.subGroup ? content.details.subGroup.split(',') : []" :key="index">{{item}}</i><span class="font-light cor999">{{content.details.releaseDate}}</span>
							</div>
						</div>
						<!-- 简介 -->
						<div class="intro bd10 p3">
							<div class="oTitle d-flex j-start">
								<h4 class="font-medium h4 font20">{{$t('show.brief')}}</h4>
							</div>
							<div class="desc font-light line-md" v-html="content.details.description"></div>
						</div>
						<!-- 相关下载 -->
						<div class="download bd10 p3">
							<div class="oTitle d-flex j-start">
								<h4 class="font-medium h4 font20">{{ $t('show.relatedDownloads') }}</h4>
							</div>
							<ul class="d-flex f-wrap">
								<li v-for="(item, index) in content.details.fileList" :key="index">
									
									<div class="item d-flex a-center j-sb"  @click="downloadFile(item.id,index)">
										<a class="t line-sm nowrap1 link">{{item.name}}</a>
										<div class="ar d-flex a-center j-end">
											<div class="downbar d-flex j-end" v-show="item.dp>0" style="margin-right: 10px;">
												<el-progress :percentage="item.dp" :show-text="true" :stroke-width="4"></el-progress>
											</div>
											<a class="d" ></a>
										</div>
									</div>
								</li>
							</ul>
						</div>
						<!-- 上下篇 -->
						<div class="pageTurning bd10 p3 d-flex j-sb">
							<p class="font-light cor999 d-flex" v-if="content.details.prev" @click="goToPage('/onlineTrainDetail?id='+content.details.prev.id)">{{ $t('show.prev') }} - <a class="link pointer">{{content.details.prev.title}}</a></p>
							<p class="font-light cor999 d-flex" v-if="content.details.next" @click="goToPage('/onlineTrainDetail?id='+content.details.next.id)"><a class="link pointer">{{content.details.next.title}}</a> - {{ $t('show.next') }}</p>
						</div>
					</div>
					<!-- 右侧目录菜单 -->
					<div class="otRightMenu">
						<!-- 目录 -->
						<div class="directory bd10 p3">
							<div class="oTitle d-flex j-start">
								<h4 class="font-medium font18 h4">{{ $t('show.directory') }}</h4>
							</div>
							<ul>
								<li :class="current==index?'cur':''"  @click="toggleChaper(item.url,item.cover,index)" v-for="(item, index) in content.details.videoList" :key="index">
									<h3 class="d-flex j-sb h3 font-light">
										<a class="link nowrap1 pointer">{{item.name}}</a><span class="cor999">{{item.duration}}</span>
									</h3>
								</li>
							</ul>
						</div>
						<!-- 相关培训 -->
						<div class="train bd10 p3">
							<div class="sTitle d-flex a-center j-sb">
								 <h3 class="font18 h3 font-medium">{{ $t('show.relatedTraining') }}</h3>
								 <a class="link font-light pointer" @click="goToPage('/onlineTrain')">{{ $t('show.more') }} &gt;</a>
							</div>
							<ul>
								<li @click="goToPage('/onlineTrainDetail?id='+item.id)" class="pointer" v-for="(item, index) in content.other" :key="index">
									<figure class="pointer pr">
										<img :src="item.cover" class="w100" alt="">
										<span><img src="@/assets/Icons/miniPlay.png" class="w100" alt=""></span>
									</figure>
									<h3 class="h3 line-sm nowrap2 font-light"><a class="link">{{item.title}}</a></h3>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
		</div>
  </div>
</template>

<script>
export default {
  name: 'OnlineTrainDetail',
  components: {
    
  },
  data() {
    return {
		// 详细信息
		content: {
			details: {
				title: ''
			}
		},
		// 视频
		current:0,
		videoUrl: '',
		videoPoster:''
	}
  },
  
  created() {
  	  // 获取详细信息
  	  this.getContentInfo(this.$route.query.id);
  	 
  },
  
  methods: {
	downloadFile(path,index){
      var that=this;
	  var id=that.$route.query.id;
      if(that.content.details.fileList[index].dp!=0){return;}
      that.$daxios
        .get(`knowledge/downLog?id=${id}&path=${path}`,{
          responseType: 'blob',
          onDownloadProgress:e=>{
            that.content.details.fileList[index].dp=Math.floor(e.progress*100);
          },
        })
        .then((res) => {
          if(res.data&&res.data.size==0){
            that.content.details.fileList[index].dp=0;
            that.$message({
              message:"下载失败",
              type: 'error'
            });
			return;
          };
          const url = window.URL.createObjectURL(new Blob([res.data]),{ type: res.headers['content-type'] });
          const link = document.createElement('a');
          let fileName = res.headers['content-file-name'];
          link.href = url;
          link.setAttribute('download', fileName);
          document.body.appendChild(link);
          link.click();
          link.remove();
		  that.content.details.fileList[index].dp=0;
        })
        .catch((err) => { 
          that.content.details.fileList[index].dp=0;
        });
    },
  	  // 页面跳转
  	  goToPage(path, query={}) {
  		  this.$router.push({
  			path,
  			query
  		  })
  	  },
	  
	  /**
	   * 切换章节
	   * @item: 当前信息
	   */
	  tabVideo(item) {
		  this.videoUrl = item.url;
		  this.videoPoster = item.cover;
		  this.$refs['video'].pause();
		  this.$refs['video'].load();
	  },
	  
	  // 获取详细信息
	  getContentInfo(id) {
		  this.$axios.get(`knowledge/trainDetails?id=${id}`)
		  .then(res => {
			  let data = res.data;
			  // 当前产品信息
			  res.data.details.fileList.forEach(i=>{i.dp=0});
			  this.content = data;
			  this.current=0;
			//   this.videoUrl = data.details.videoList[0].url;
			//this.videoPoster = data.details.videoList[0].cover;
			this.toggleChaper(data.details.videoList[0].url,data.details.videoList[0].cover,0)
			  document.title = data.details.title;
		  })
		  .catch(err=>{})
	  },
	  toggleChaper(url,poster,index){
		var that=this;
		that.videoUrl = url;
		that.videoPoster = poster;
		that.$refs['video'].pause();
		that.$refs['video'].load();
		that.current = index;
		
	  }
	},
	
	// 监听
	watch: {
		  // 路由变化
		  '$route'(to, from) {
			  // 重新获取详细信息
			  this.getContentInfo(this.$route.query.id);
		  } 
	}
}
</script>

<style lang="less" scoped>
	.otDetail{
		padding-top: .6rem;
		.otLeftContent{
			width: calc(100% - 3.5rem);
		}
		.otRightMenu{
			width: 3.3rem;
		}
		@media (max-width: 1200px) {
			flex-direction: column;
			.otLeftContent,
			.otRightMenu{
				width: 100%;
			}
				
			.otRightMenu{
				margin-top: .3rem;
			}
		}
	}
	.otRightMenu{
		.directory{
			margin-bottom: .1rem;
			ul li{
				&:not(:last-child) {
					margin-bottom: .15rem;
				}
				&.cur a{
					color: #2657db;
					font-weight: bold;
				}
			}
			
		}
		.train{
			ul li{
				&:not(:last-child) {
					margin-bottom: .25rem;
				}
				figure{
					border-radius: 5px;
					overflow: hidden;
					margin-bottom: .15rem;
				}
				span{
					position: absolute;
					left: .1rem;
					bottom: .1rem;
					width: .2rem;
					z-index: 2;
				}
			}
		}
	}
	.otLeftContent{
		& > div:not(:last-child){
			margin-bottom: .1rem;
		}
		.download{
			ul{
				margin: 0 -.1rem;
				margin-top: -.2rem;
				li{
					width: 50%;
					padding: 0 .1rem;
					margin-top: .2rem;
					.item{
						background: #f8f8f8;
						height: .6rem;
						padding: 0 .2rem;
					}
					.t{
						display: block;
						padding-left: .35rem;
						background: url(@/assets/Icons/pdf.png) no-repeat 0 center/.16rem;
						width: calc(100% - .35rem);
					}
					.d{
						width: .18rem;
						height: .18rem;
						background: url(@/assets/Icons/downloadHrefBlue.png) no-repeat 0 center/100% 100%;
					}
				}
			}
		}
		.intro{
			.desc{
				min-height: 1.5rem;
			}
		}
		.tVideo{
			h3{
				margin: .2rem 0;
			}
			i{
				margin-right: .2rem;
			}
		}
		.video{
			height: 6.6rem;
			border-radius: .1rem;
			overflow: hidden;
			background: #333;
			video{
				height: 6.6rem;
				object-fit: cover;
				width: 100%;
			}
		}
		@media (max-width: 1200px) {
			.video{
				height: 4rem;
				video{
					height: 4rem;
				}
			}
		}
		@media (max-width: 640px) {
			.video{
				height: 3rem;
				video{
					height: 3rem;
				}
			}
			.download{
				ul{
					li{
						width: 100%;
					}
				}
			}
		}
	}
</style>
